import { render, staticRenderFns } from "./AppDocumentIcon.vue?vue&type=template&id=11360762&scoped=true&"
import script from "./AppDocumentIcon.vue?vue&type=script&lang=js&"
export * from "./AppDocumentIcon.vue?vue&type=script&lang=js&"
import style0 from "./AppDocumentIcon.vue?vue&type=style&index=0&id=11360762&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11360762",
  null
  
)

export default component.exports